<template>
  <div class="demo-system-main"  v-title data-title="演示系统">
    <Title />
    <Nav />
  </div>
</template>

<script>
import Title from '@/components/demoSystem/Title'
import Nav from '@/components/demoSystem/Nav'

export default {
  name: 'DemoSystem',
  components: {
    Title,
    Nav
  }
}
</script>

<style lang="scss" scoped>
.demo-system-main {
  height: 100%;
  min-width: 1200px;
  min-height: 600px;
  background-image: url("../assets/images/demoSystem/bg.jpg");
  background-color: #010624;
  background-size: 100% auto;
  background-repeat: no-repeat;
  overflow-x: auto;
}
</style>
